module.exports = __webpack_public_path__ + "static/media/instagramIcon.f405ec37.svg";